// extracted by mini-css-extract-plugin
module.exports = {"engagementScoreFlames":"styles_engagementScoreFlames__iQPqi","off":"styles_off__2FeiE","on":"styles_on__1xqts"};